import { render, staticRenderFns } from "./realtimedata.vue?vue&type=template&id=3ff720ba&scoped=true&"
import script from "./realtimedata.vue?vue&type=script&lang=ts&"
export * from "./realtimedata.vue?vue&type=script&lang=ts&"
import style0 from "./realtimedata.vue?vue&type=style&index=0&id=3ff720ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff720ba",
  null
  
)

export default component.exports